import { render, staticRenderFns } from "./UserDialogHeader.vue?vue&type=template&id=37e75952"
import script from "./UserDialogHeader.vue?vue&type=script&lang=js"
export * from "./UserDialogHeader.vue?vue&type=script&lang=js"
import style0 from "./UserDialogHeader.vue?vue&type=style&index=0&id=37e75952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports